import { render } from "./PaymentSidebar.vue?vue&type=template&id=91cea6e0"
import script from "./PaymentSidebar.vue?vue&type=script&lang=js"
export * from "./PaymentSidebar.vue?vue&type=script&lang=js"

import "./PaymentSidebar.vue?vue&type=style&index=0&id=91cea6e0&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__